import { Component, Input } from '@angular/core';
import { SocialMedia } from '../../../profiles/dashboard/elements/company-metrics/company-metrics.interface';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faTiktok,
  faFacebook,
  faInstagram,
  faLinkedin,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  selector: 'app-social-media-bar',
  templateUrl: './social-media-bar.component.html',
  styleUrls: ['./social-media-bar.component.scss'],
  imports: [FontAwesomeModule, NgForOf, NgIf],
  standalone: true,
})
export class SocialMediaBarComponent {
  @Input() public socialMediaLinks: SocialMedia | undefined;

  private socialMediaLookup: Record<keyof SocialMedia, IconProp> = {
    tiktok: faTiktok,
    linkedin: faLinkedin,
    youtube: faYoutube,
    x: faXTwitter,
    facebook: faFacebook,
    instagram: faInstagram,
  };

  private _socialMedia: { icon: IconProp; link: string }[] | undefined;

  public get socialMedia(): { icon: IconProp; link: string }[] | undefined {
    if (!this._socialMedia) {
      if (!this.socialMediaLinks) {
        console.log('No social media links available.');
        return;
      }

      this._socialMedia = Object.keys(this.socialMediaLinks).map((key) => {
        return {
          icon: this.socialMediaLookup[key as keyof SocialMedia],
          link: this.socialMediaLinks![key as keyof SocialMedia],
        };
      });

      console.log('get socialMedia run'); // Log the populated social media data
    }
    return this._socialMedia;
  }
  
  public navigateTo(link: string): void {
    console.log('navigateTo run ');
    if (link) {
      window.open(link, '_blank'); // Opens the link in a new tab
    } else {
      console.error('No link provided for navigation');
    }
  }
}
